import { IDirective, IDirectiveFactory, INgModelController, IAugmentedJQuery, IAttributes } from "angular";

import { InsightSelectorCtrl, IInsightSelectorScope } from "./insight-selector.ctrl";

export class InsightSelector implements IDirective {
  public require = ["insightSelector", "ngModel"];
  public restrict = "A";
  public templateUrl = require("./insight-selector.jade");
  public scope = {
    data: "=ngModel",
    type: "=?",
    name: "=?",
    readOnly: "=?",
    kpiId: "=?",
    selectedKpiCellGroupId: "=?",
  };
  public controller = InsightSelectorCtrl;

  public link(scope: IInsightSelectorScope, element: IAugmentedJQuery, attributes: IAttributes, controllers: [InsightSelectorCtrl, INgModelController]): void {
    // our component controller and the ngModel controller exposed on the DOM.
    const [insightSelectorCtrl, ngModelCtrl] = controllers;

    // since the available ngModelControllers are a result of the DOM
    // structure, we have to get them from the link function. However,
    // once the DOM has linked, we can pass the available ngModelController
    // into our component directive controller.
    insightSelectorCtrl.setNgModelController(ngModelCtrl);
  }

  public static factory(): IDirectiveFactory {
    const directive = () => new InsightSelector();
    directive.$inject = [];
    return directive;
  }
}
